import { render, staticRenderFns } from "./Optimizer.vue?vue&type=template&id=07175012&scoped=true&"
import script from "./Optimizer.vue?vue&type=script&lang=js&"
export * from "./Optimizer.vue?vue&type=script&lang=js&"
import style0 from "./Optimizer.vue?vue&type=style&index=0&id=07175012&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07175012",
  null
  
)

export default component.exports